import useHelpModalState from './useHelpModalState';

const useHelpModal = () => {
  const { visible, dispatchHelpModalVisibility } = useHelpModalState();
  return { visible, dispatchHelpModalVisibility };
};

export default useHelpModal;
